module.exports = __webpack_public_path__ + "images/8e9724278295f16f09a3d2f4b62e18de7.svg";